import { faker } from '@faker-js/faker';
// @mui
import { useState, useEffect } from 'react';
import { useTheme, styled } from '@mui/material/styles';
import { Grid, Container, Typography } from '@mui/material';
// components
import { PowerBIEmbed } from 'powerbi-client-react';
import {models}  from 'powerbi-client';
// import { styled } from '@mui/material/styles';
// import Page from '../components/Page';
// import Iconify from '../components/Iconify';
import PropTypes from 'prop-types';
import SwipeableViews from 'react-swipeable-views';
import AppBar from '@mui/material/AppBar';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Box from '@mui/material/Box';
import Page from '../components/Page';
import Iconify from '../components/Iconify';
import AppCache from '../services/AppCache';


import '../services/PowerBiEmbedStyleSheet.css';
import URLS from '../services/urls.service';
// sections
import {
    AppTasks,
    AppNewsUpdate,
    AppOrderTimeline,
    AppCurrentVisits,
    AppWebsiteVisits,
    AppTrafficBySite,
    AppWidgetSummary,
    AppCurrentSubject,
    AppConversionRates,
} from '../sections/@dashboard/app';
// ----------------------------------------------------------------------


//   const dashboardArray = [
//    {
//        dashboardId: 1,
//        DashboardName: 'RLS',

//    },
//    {
//        dashboardId: 2,
//        DashboardName: 'RLS 1',

//    },
//    {
//        dashboardId: 3,
//        DashboardName: 'RLS 3',

//    },

//  ]



const AntTabs = styled(Tabs)({
    borderBottom: '1px solid #4e342e',

    position: 'sticky',

    '& .MuiTabs-indicator': {

    },
});

const AntTab = styled((props) => <Tab disableRipple {...props} />)(({ theme }) => ({
    textTransform: 'none',
    minWidth: 0,
    [theme.breakpoints.up('sm')]: {
        minWidth: 0,
    },
    fontWeight: theme.typography.fontWeightRegular,
    marginRight: theme.spacing(1),
    fontsize: '20px',
    color: '#E7000B',
    Transition: '2s',
    fontFamily: [
        '-apple-system',
        'BlinkMacSystemFont',
        '"Segoe UI"',
        'Roboto',
        '"Helvetica Neue"',
        'Arial',
        'sans-serif',
        '"Apple Color Emoji"',
        '"Segoe UI Emoji"',
        '"Segoe UI Symbol"',
    ].join(','),
    '&:hover': {
        color: '#4e342e',

        opacity: 1,
    },
    '&.Mui-selected': {
        color: '#4e342e',

        fontWeight: theme.typography.fontWeightMedium,

    },
    '&.Mui-focusVisible': {
        backgroundColor: '#fff',
    },
}));

function TabPanel(props) {
    const { children, value, index, ...other } = props;
    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`full-width-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box >
                    <Typography>{children}</Typography>
                </Box>
            )}
        </div>
    );
}

TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.number.isRequired,
    value: PropTypes.number.isRequired,
};

function a11yProps(index) {
    return {
        id: `simple-tab-${index}`,
        'aria-controls': `simple-tabpanel-${index}`,
    };
}


export default function DashboardApp() {
    const theme = useTheme();
    const [value, setValue] = useState(0);
    const [dashboardTabsArray, setdashboardTabsArray] = useState([]);
    const handleChange = (event, newValue) => {

        console.log("response  event.target  ", event.target);
        console.log("response  event.target.value ", event.target.value);
        console.log("response  newValue  ", newValue);
        setValue(newValue);

    };




    const handleHide = () => {
        // setHide(true)
    };

    const handleShow = () => {
        // setHide(false)
    };
    const file = '/static/Dashboard.pdf'
    const type = 'pdf'
    const containerStyle = {
        width: '100%',
        margin: 0,
        overflow: 'hidden',
    };

    const fileViewerStyle = {
        width: '100%',
        height: '600px',
        border: 'none',
        overflow: 'hidden',
        objectFit: 'contain'
    };
    const CurrentLoggedInUser = AppCache.GetCurrentLoggedInUser();

    const [testData, setTestData] = useState([]);
    const desiredHeight = '600px';
    const [userId, setUserId] = useState([]);
    const [DashboardURL, setDashboardURL] = useState([]);
    const [IspowerBI, setIspowerBI] = useState([]);
    const [embedConfigId, setEmbedConfigId] = useState([]);
    const [embedConfigEmbedUrl, setEmbedConfigEmbedUrl] = useState("");
    const [embedConfigAccessToken, setEmbedConfigAccessToken] = useState("");
    const [embedConfigExpiration, setEmbedConfigExpiration] = useState("");

    const [dashboardData, setDashboardData] = useState([]);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        // PreviousUrl calls
        URLS.configFileURL().then((response) => {
            if (response.status === 200) {
                const config = JSON.parse(JSON.stringify(response.data));
                // AppCache.SetCurrentAPIURL(config.SmileServiceApiBaseUrl);
                //   AppCache.SetPowerBIURL(config);
            }
            else {
                // Failure response
                alert("Api URL  Failed");
            }
        })

        setUserId(CurrentLoggedInUser.ExecutiveId);
        const LoginId = CurrentLoggedInUser.ExecutiveId;
        const payload = {
            UserID: LoginId,
            TabName: ""
        }
        console.log("payload", payload);
        URLS.getPowerBIDashBoard(payload)
            .then((response) => {
                setDashboardData(response.data);
                //    console.log("response response.data  ", response.data);
                //    console.log("DashboardURL ", response.data.DashboardURL);
                //    console.log("IspowerBI ", response.data.IspowerBI);

                setDashboardURL(response.data.DashboardURL);
                setIspowerBI(response.data.IspowerBI);
                setdashboardTabsArray(response.data.DashboardTabslist || []);

                const arrayControlValue = response.data.DashboardURL;
                const arrayMenu = arrayControlValue.split(',');
                const RLS = arrayMenu[0];
                const userName = arrayMenu[1];

                // console.log("response username use effect", userName);

                // const userName = "=232&ReportId=cee14564-601d-4cd7-ab92-d7b1f394c975&DatasetId=603199d7-276a-48d2-a8cb-420ae6f44121";

                if (RLS === 'NO') {
                    URLS.getPowerBINoRlsData(userName)
                        .then((response) => {
                            setEmbedConfigId(response.data.Id);
                            setEmbedConfigEmbedUrl(response.data.EmbedUrl);
                            setEmbedConfigAccessToken(response.data.EmbedToken.Token);
                            setEmbedConfigExpiration(response.data.EmbedToken.Expiration);
                            setTestData(response.data);

                            // console.log(" testData.setEmbedConfigId, RLS = No ", testData.Id);
                            setEmbedConfigId(testData.Id);
                            //  console.log(" testData.EmbedToken.Token , RLS = No ", testData.EmbedToken.Token);

                            //  setEmbedConfigAccessToken(testData.EmbedToken.Token);



                        })
                        .catch(error => {
                            // On error
                            console.log(" Error URLS.getPowerBIData(userName), RLS = NO ", error);
                        });

                    //  displayNORLSDashboard(userName);
                } else if (RLS === 'YES') {
                    URLS.getPowerBIData(userName)
                        .then((response) => {
                            setEmbedConfigId(response.data.Id);
                            setEmbedConfigEmbedUrl(response.data.EmbedUrl);
                            setEmbedConfigAccessToken(response.data.EmbedToken.Token);
                            setEmbedConfigExpiration(response.data.EmbedToken.Expiration);

                            setTestData(response.data);

                            // setEmbedConfigId(testData.Id);
                            //  console.log(" testData.EmbedToken.Token , RLS = YES ", testData.EmbedToken.Token);

                            // setEmbedConfigAccessToken(testData.EmbedToken.Token);

                        })
                        .catch(error => {
                            // On error
                            console.log(" Error URLS.getPowerBIData(userName), RLS = YES ", error);
                        });
                }
            })
            .catch(error => {
                console.log(" Error ");
            });

    }, []);


    const tabHandleChange = (event, newValue, dashboardName) => {
        //   console.log("response  event.target  ", event.target);
        //  console.log("response  event.target.value ", event.target.value);
        console.log("response  dashboardName ", dashboardName);
        console.log("response  newValue  ", newValue);


        setValue(newValue);
        setLoading(true);

        setUserId(CurrentLoggedInUser.ExecutiveId);
        const LoginId = CurrentLoggedInUser.ExecutiveId;
        const TabNameValue = dashboardName;
        const payload = {
            UserID: LoginId,
            TabName: TabNameValue
        }
        console.log("payload", payload);
        URLS.getPowerBIDashBoard(payload)
            .then((response) => {
                console.log("response ", response);
                setDashboardData(response.data);
                setDashboardURL(response.data.DashboardURL);
                setIspowerBI(response.data.IspowerBI);
              /*  setdashboardTabsArray(response.data.DashboardTabslist || []); */

                const arrayControlValue = response.data.DashboardURL;
                const arrayMenu = arrayControlValue.split(',');
                const RLS = arrayMenu[0];
                const userName = arrayMenu[1];

                console.log("response username", userName);
                // const userName = "=232&ReportId=cee14564-601d-4cd7-ab92-d7b1f394c975&DatasetId=603199d7-276a-48d2-a8cb-420ae6f44121";
                if (RLS === 'NO') {

                    URLS.getPowerBINoRlsData(userName)
                        .then((response) => {
                            console.log("response No RLS ", response);
                            setEmbedConfigId(response.data.Id);
                            setEmbedConfigEmbedUrl(response.data.EmbedUrl);
                            setEmbedConfigAccessToken(response.data.EmbedToken.Token);
                            setEmbedConfigExpiration(response.data.EmbedToken.Expiration);
                            setTestData(response.data);
                            setLoading(false);

                            console.log(" response.data.EmbedToken.Expiration, RLS = No ", response.data.EmbedToken.Expiration);
                            console.log(" response.data.Id , RLS = No ", response.data.Id);
                            console.log(" response.data.EmbedToken.Token , RLS = No ", response.data.EmbedToken.Token);
                            console.log(" testData.embedConfigAccessToken, RLS = No ", testData.EmbedToken.Token);
                            console.log(" testData.setEmbedConfigId, RLS = No ", testData.Id);
                            //   setEmbedConfigId(testData.Id);
                            //  setEmbedConfigAccessToken(testData.EmbedToken.Token);

                            // setTestData(response.data);
                        })
                        .catch(error => {
                            // On error
                            console.log(" Error URLS.getPowerBIData(userName), RLS = NO ", error);
                            setLoading(false);
                        });
                }
                else if (RLS === 'YES') {
                    URLS.getPowerBIData(userName)
                        .then((response) => {
                            console.log("response Yes RLS ", response);

                            setEmbedConfigId(response.data.Id);
                            setEmbedConfigEmbedUrl(response.data.EmbedUrl);
                            setEmbedConfigAccessToken(response.data.EmbedToken.Token);
                            setEmbedConfigExpiration(response.data.EmbedToken.Expiration);
                            setTestData(response.data);
                            setLoading(false);
                            //  setEmbedConfigId(testData.Id);
                            //  setEmbedConfigAccessToken(testData.EmbedToken.Token);

                            console.log(" response.data.EmbedToken.Expiration, RLS = YES ", response.data.EmbedToken.Expiration);
                            console.log(" testData.embedConfigAccessToken, RLS = YES ", testData.EmbedToken.Token);

                        })
                        .catch(error => {
                            // On error
                            console.log(" Error URLS.getPowerBIData(userName), RLS = YES ", error);
                            setLoading(false);
                        });
                }
            })
            .catch(error => {
                console.log(" Error ");
                setLoading(false);
            });
    }
    console.log("dashboardarray>>>>>>>>>>>>>>>>>>>>>>>>>>>>>", dashboardTabsArray)

    return (
        <Page title="Dashboard"  >

            <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                {/*    <AntTabs value={value} onChange={handleChange} variant="fullWidth" aria-label="basic tabs example">    */}
                <AntTabs value={value} variant="fullWidth" aria-label="basic tabs example">
                    {(dashboardTabsArray || []).map((dashboard, index) => (
                        // <AntTab key={dashboard.dashboardId} onClick={(event) => handleChange(event, index)} label={dashboard.DashboardName} />
                        <AntTab key={dashboard.dashboardId} onClick={(event) => tabHandleChange(event, index, dashboard.DashboardName)} label={dashboard.DashboardName} />
                    ))}
                </AntTabs>
            </Box>


            {(dashboardTabsArray || []) .map((dashboard, index) => ( 
                <TabPanel key={dashboard.dashboardId} onChange={handleChange} value={value} index={index} > 
                    <div>
                        {loading ? (
                           <div/>
                        ) : (
                                <PowerBIEmbed
                                    embedConfig={{
                                        type: 'report',   // Supported types: report, dashboard, tile, visual and qna 
                                        //  id: testData.embedConfigId, 
                                        // id: "cee14564-601d-4cd7-ab92-d7b1f394c975", 
                                        id: embedConfigId,

                                        //  accessToken: testData.EmbedToken.Token, 



                                        accessToken: embedConfigAccessToken,
                                        // accessToken: embedConfigAccessToken, 
                                        // tokenType: models.TokenType.Aad, 
                                        // embedUrl: embedConfigEmbedUrl, 

                                        // id: embedConfigId, 
                                        embedUrl: testData.EmbedUrl,
                                        // accessToken: embedConfigAccessToken, 
                                        // tokenType: models.TokenType.Aad, 
                                        tokenType: models.TokenType.Embed, // Use models.TokenType.Aad for SaaS embed 
                                        // tokenExpiry = embedConfigExpiration, 


                                        settings: {
                                            panes: {
                                                filters: {
                                                    expanded: true,
                                                    visible: true
                                                }
                                            },
                                        }
                                    }}

                                    eventHandlers={
                                        new Map([
                                            ['loaded', function () { console.log('Report loaded'); }],
                                            ['rendered', function () { console.log('Report rendered'); }],
                                            ['error', function (event) { console.log('PowerBi Error rendered'); console.log(event.detail); }]
                                        ])
                                    }

                                    //  cssClassName="Embed-container" 
                                    cssClassName="Embed-container"


                                    getEmbeddedComponent={(embeddedReport) => {
                                        window.report = embeddedReport;
                                    }
                                    }
                                /> 
                        )
                    }
                        
                    </div> 
                </TabPanel> 




             ))} 

        </Page>
    );
}
